import { render, staticRenderFns } from "./DeliveryLocation.vue?vue&type=template&id=2ef07f49&scoped=true&"
import script from "./DeliveryLocation.vue?vue&type=script&lang=js&"
export * from "./DeliveryLocation.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryLocation.vue?vue&type=style&index=0&id=2ef07f49&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef07f49",
  null
  
)

export default component.exports